export default "__VITE_ASSET__UuUgBHiy__"